import axios from 'axios';

import WP from 'WP';

export default {

    getMenuById: id => axios.get(WP.api_base+'wp-api-menus/v2/menus/'+id),

    getHomePage: () => {
        return axios.get(WP.api_base+'wp/v2/pages/'+WP.front_page, {
            params: {
                nocache: new Date().getTime()
            }
        })
    },

    getPageBySlug: slug => {
        return axios.get(WP.api_base+'wp/v2/pages', {
            params: { 
                slug: slug,
                lang: WP.lang,
                nocache: new Date().getTime()
            }
        })
    },

    getEmployees: () => {
        return axios.get(WP.api_base+'wp/v2/employees', {
            params: { 
                lang: WP.lang,
                order: 'asc',
                per_page: 50,
                nocache: new Date().getTime()
            }
        })
    },

    getEmployee: id => {
        return axios.get(WP.api_base+'wp/v2/employees/'+id)
    },

    getTerms: taxonomy => {
        return axios.get(WP.api_base+'hlm/v2/terms', {
            params: { 
                lang: WP.lang,
                taxonomy: taxonomy,
                nocache: new Date().getTime()
            }
        })
    },

    getNews: ({ limit }) => {
        return axios.get(WP.api_base+'wp/v2/posts', {
            params: { 
                lang: WP.lang,
                per_page: limit || 20,
                nocache: new Date().getTime()
            }
        })
    },

    getPostBySlug: slug => {
        return axios.get(WP.api_base+'wp/v2/posts', {
            params: { 
                slug: slug,
                lang: WP.lang,
                nocache: new Date().getTime()
            }
        })
    },

    getProjects: () => {
        return axios.get(WP.api_base+'wp/v2/projects', {
            params: { 
                lang: WP.lang,
                order: 'asc',
                //'filter[orderby]': 'menu_order',
                per_page: 50,
                nocache: new Date().getTime()
            }
        })
    },

    getProjectBySlug: slug => {
        return axios.get(WP.api_base+'wp/v2/projects', {
            params: { 
                slug: slug,
                lang: WP.lang,
                nocache: new Date().getTime()
            }
        })
    },

    getTours: () => {
        return axios.get(WP.api_base+'wp/v2/tours', {
            params: { 
                lang: WP.lang,
                order: 'desc',
                per_page: 50,
                nocache: new Date().getTime()
            }
        })
    },

    getTourBySlug: slug => {
        return axios.get(WP.api_base+'wp/v2/tours', {
            params: { 
                slug: slug,
                lang: WP.lang,
                nocache: new Date().getTime()
            }
        })
    },

    getRelatedPosts: id => {
        return axios.get(WP.api_base+'hlm/v2/related/'+id, {
            params: {
                nocache: new Date().getTime()
            }
        })
    },

    search: query => {
        return axios.get(WP.api_base+'hlm/v2/search', {
            params: { 
                query: query,
                lang: WP.lang,
                nocache: new Date().getTime()
            }
        })
    },

}


// WEBPACK FOOTER //
// ./src/api.js